import { useEffect, useState } from 'react';

export function useTimeoutEffect(valueExecutor: boolean, customDelay?: number): boolean {
  const delay = customDelay ?? 1000;
  const [value, setValue] = useState(false);

  useEffect(() => {
    if (valueExecutor) {
      setTimeout(() => {
        setValue(true);
        setTimeout(() => {
          setValue(false);
        }, delay);
      }, 0);
    }
  }, [delay, valueExecutor]);

  return value;
}
